export default function Footer() {
  return <footer>© Kewin Dousse 2014 - 2024</footer>;
}
